import React, { FC } from 'react';
import { SiteInfoFieldsProps } from './SiteInfoFieldsProps';
import CustomInput from '../../../common/CustomInput';
import CustomNumberInput from '../../../common/CustomNumberInput';
import useTranslation from '../../../hooks/useTranslation';
import SiteInfoSelects from './SiteInfoSelects';
import { TransactionType } from '../../../models/project';
import CustomSelect from '../../../common/CustomSelect';

const SiteInfoFields: FC<SiteInfoFieldsProps> = ({
  transactionType,
  isLeasedFromAnotherIngkaCompany,
  unitType,
  unit,
  land,
  lease,
  building,
  site,
  newUnitType,
  unitCategoryDisabled,
  currencyRate,
  currency,
}) => {
  const t = useTranslation();
  return (
    <>
      <SiteInfoSelects
        transactionType
        unitType={unitType}
        siteType={site}
        newUnitType={newUnitType}
        unitCategoryDisabled={unitCategoryDisabled}
      />
      {transactionType === TransactionType.LEASE && (
        <CustomSelect
          optionsArray={{
            true: t('common.yes'),
            false: t('common.no'),
          }}
          name={'isLeasedFromAnotherIngkaCompany'}
          required
          label={t('labels.leasedFromIngka')}
          dataTestID={'leased-from-ingka-select'}
        />
      )}
      {lease &&
        transactionType === TransactionType.LEASE &&
        isLeasedFromAnotherIngkaCompany === 'false' && (
          <CustomInput
            name={'leasePeriod'}
            label={t('labels.leasePeriod')}
            dataTestID={'lease-period'}
            helperText={t('labels.examplePlaceholderLeasePeriod')}
          />
        )}

      {lease &&
        transactionType === TransactionType.LEASE &&
        isLeasedFromAnotherIngkaCompany === 'false' && (
          <>
            <CustomNumberInput
              name={'totalLeaseAmount'}
              label={t('labels.externalLeaseCommitment')}
              currencySymbol={currency}
              dataTestID={'external-lease-commitment'}
              currencyRate={currencyRate}
              helperText={t('labels.examplePlaceholderExternalLease')}
            />

            <CustomNumberInput
              name={'costAtLeaseEnd'}
              label={t('labels.costAtLeaseEnd')}
              currencySymbol={currency}
              dataTestID={'cost-at-lease-end'}
              currencyRate={currencyRate}
              helperText={t('labels.examplePlaceholderCostAtEnd')}
            />
          </>
        )}

      {unit && (
        <CustomInput
          name={'grossUnitArea'}
          type={'number'}
          label={t('labels.grossUnitArea')}
          dataTestID={'gross-unit-area'}
          helperText={t('labels.examplePlaceholderGrossUnit')}
        />
      )}
      {land && (
        <CustomInput
          name={'landSize'}
          label={t('labels.landSize')}
          type={'number'}
          dataTestID={'land-size'}
          helperText={t('labels.examplePlaceholderLand')}
        />
      )}
      {building && (
        <CustomInput
          name={'grossBuildingArea'}
          type={'number'}
          label={t('labels.grossBuildingArea')}
          dataTestID={'gross-building-area'}
          helperText={t('labels.examplePlaceholderGrossBuilding')}
        />
      )}
    </>
  );
};

export default SiteInfoFields;
